import classNames from "classnames";
import React, { FC, useState } from "react";
import { DraggableProvidedDragHandleProps } from "react-beautiful-dnd";
import { RxDragHandleDots2 } from "react-icons/rx";

import { SettingsIconButton } from "../../../../components/button/SettingsIconButton";
import { ColorPicker } from "../../../../components/colorPicker/ColorPicker";
import { SettingsDropdown } from "../../../../components/dropdown/SettingsDropdown";
import { DotsSvg } from "../../../../components/svg/DotsSvg";
import { EditPencilSvg } from "../../../../components/svg/EditPencilSvg";
import { TrashSvg } from "../../../../components/svg/TrashSvg";
import { BillingStatusType } from "../../../../services/BillingService";
import { SettingsFormInput } from "../../components/SettingsFormInput";

type Props = {
  handleUpdate: (status: BillingStatusType) => Promise<void>;
  handleDelete: (status: BillingStatusType) => void;
  isUpdating: boolean;
  isLast?: boolean;
  status: BillingStatusType;
  dragHandleProps: DraggableProvidedDragHandleProps | null | undefined;
};

export const BillingStatus: FC<Props> = ({
  status,
  isUpdating,
  isLast,
  handleUpdate,
  handleDelete,
  dragHandleProps,
}) => {
  const [color, setColor] = useState(status?.color || "#444444");
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);

  if (isOpenUpdate) {
    return (
      <SettingsFormInput
        onSave={async (value) => {
          await handleUpdate({ ...status, color: color, name: value });
          setIsOpenUpdate(false);
        }}
        onCancel={() => setIsOpenUpdate(false)}
        isLoading={isUpdating}
        placeholder={"Type label name..."}
        defaultValue={status?.name}
        left={
          <ColorPicker
            value={color}
            onChange={(value) => setColor(value)}
            preview={"Preview"}
          />
        }
      />
    );
  }

  return (
    <div
      className={classNames(
        "flex items-center justify-between gap-4 px-4 py-2",
        !isLast ? "border-b border-[#C8D2DE]" : "",
      )}>
      <div className={"flex items-center gap-4"}>
        <div {...dragHandleProps}>
          <RxDragHandleDots2 size={24} className={"text-gray-200"} />
        </div>
        <div
          style={{ background: status?.color }}
          className={"h-6 w-6 rounded-full"}
        />
        <div
          title={status?.name}
          className={"truncate text-base font-medium text-[#3F5266]"}>
          {status.name}
        </div>
      </div>
      <SettingsDropdown
        actionsList={[
          {
            name: "Edit",
            action: () => setIsOpenUpdate(true),
            icon: <EditPencilSvg />,
          },
          {
            name: "Delete",
            action: () => handleDelete(status),
            icon: <TrashSvg />,
            extraClasses: "text-[#DC2626]",
            iconColor: "text-[#DC2626]",
          },
        ]}>
        <SettingsIconButton
          icon={<DotsSvg />}
          onClick={() => null}
          size={"small"}
        />
      </SettingsDropdown>
    </div>
  );
};
